import { Checkbox } from 'primereact/checkbox';
import { Dropdown } from 'primereact/dropdown';
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import { classNames } from 'primereact/utils';
import React, { memo, useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import AutoSave from '../../Utils/AutoSave';
import { getEndpointUrl } from '../../Utils/Common';

const FormOnChange = ({ setLoading, element, entry, fKey }) => {

    const params = useParams();

    const methods = useForm({
        mode: "onSubmit"
    });

    const {
        register,
        control,
        handleSubmit,
        reset,
        formState: { errors }
    } = methods;

    const [submittedData, setSubmittedData] = useState({});

    const [selectedAvailability, setSelectedAvailability] = useState([null]);
    const [selectedChoices, setSelectedChoice] = useState([]);
    const [selectedConditions, setSelectedConditions] = useState([]);
    const [otherInput, setOtherInput] = useState('');

    const navigate = useNavigate();

    const [accesToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    let entryData = entry.filter(item => item.name == element.name).at(0);

    useEffect(() => {

        let defaultValues = {};

        if (entryData != undefined) {
            defaultValues.note = entryData.note;
            defaultValues.availability = entryData.availability;

            if (element.type == 'select') {
                setSelectedAvailability(element.choices.filter(item => item.name == entryData.availability).at(0));
                setSelectedChoice(entryData.choices != '' ? JSON.parse(entryData.choices) : []);

                if (entryData.otherChoice !== '' || entry.otherChoice !== null) {
                    setOtherInput(entryData.otherChoice);

                    let _selected = [...selectedChoices];
                    _selected.push(entryData.otherChoice);
                }

                defaultValues.condition = selectedChoices?.length > 0 ? JSON.stringify(selectedChoices) : '';

                defaultValues.choices = selectedChoices?.length > 0 ? JSON.stringify(selectedChoices) : '';
            } else {
                let dataEntried = entryData.choices != '' ? JSON.parse(entryData.choices) : [];

                if (entryData.otherChoice !== '' || entry.otherChoice !== null) {
                    setOtherInput(entryData.otherChoice);

                    let _selected = [...selectedChoices];
                    _selected.push(entryData.otherChoice);
                }

                setSelectedChoice(dataEntried);
                defaultValues.condition = dataEntried?.length > 0 ? JSON.stringify(dataEntried) : '';

                defaultValues.choices = dataEntried?.length > 0 ? JSON.stringify(dataEntried) : '';
            }
        }

        reset({ ...defaultValues });
    }, [entry]);

    useEffect(() => {
        let defaultValues = {};
        if (entryData != undefined)
            defaultValues.note = entryData.note;

        defaultValues.availability = selectedAvailability.name;

        defaultValues.condition = selectedChoices?.length > 0 ? JSON.stringify(selectedChoices) : '';
        defaultValues.choices = selectedChoices?.length > 0 ? JSON.stringify(selectedChoices) : '';

        reset({ ...defaultValues });

        // methods.handleSubmit(onSubmit)();

    }, [selectedAvailability, selectedChoices, selectedConditions, otherInput]);

    const onChoicesAvailabilityChange = (e) => {
        let _selected = [...selectedChoices];
        if (e.checked)
            _selected.push(e.value);
        else
            _selected = _selected.filter(item => item !== e.value);

        setSelectedChoice(_selected);

        methods.handleSubmit(onSubmit)();
    };

    const onChoicesOtherAvailabilityChange = (e) => {
        let _selected = [...selectedChoices];
        if (e.checked)
            _selected.push(e.value);
        else {
            _selected = _selected.filter(item => item !== e.value);
            setOtherInput('');
        }
    }

    const onSubmit = (data) => {
        setLoading(true);

        console.log("SEND IT",data)

        let formData = new FormData();    //formdata object

        formData.append('item_id', params.item_id);
        formData.append('index', element.id);
        formData.append('category', params.category);

        formData.append('name', element.name);
        formData.append('availability', (data.availability !== undefined) ? data.availability : 'DILENGKAPI');
        formData.append('choices', data.condition);
        formData.append('otherChoice', (data.otherChoice !== undefined) ? data.otherChoice : '');
        formData.append('note', data.note);
        formData.append('image', data.file?.[0]);

        fetch(getEndpointUrl() + '/checkpoint/send', {
            method: "POST",
            body: formData,
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            // if (json.status === 'ok') {
            //     onCallback(json.results.data);
            // } else {

            // }
            setLoading(false);
        }).catch(error => {
            setLoading(false);
        });
    };

    return (
        <FormProvider {...methods} key={fKey}>
            <Form onSubmit={handleSubmit(onSubmit)} className="mb-5">
                <AutoSave onSubmit={onSubmit} />
                <Row>
                    <Col>
                        <div className="page-title">
                            <h3>{`${element.id}. ${element.name}`}</h3>
                        </div>
                    </Col>
                </Row>

                {element.type == 'select' ?
                    <>
                        <Row className="mb-3">
                            <Col>
                                <Form.Label className='fw-bold'>Kelengkapan :</Form.Label>
                                <div className="clearfix" />
                                <Controller
                                    name={`availability`}
                                    rules={{ required: "Field wajib diisi!" }}
                                    render={({ field }) => (
                                        <Dropdown
                                            {...field}
                                            optionLabel="name"
                                            placeholder="Pilih Kelengkapan"
                                            id={field.name}
                                            options={element.choices}
                                            value={selectedAvailability}
                                            onBlur={(e) => methods.handleSubmit(onSubmit)()}
                                            onChange={(e) => {
                                                setSelectedAvailability(e.value)
                                                setSelectedChoice([]);
                                                setSelectedConditions([]);
                                            }}
                                            className={classNames({ 'p-invalid': errors.availability })}
                                        />
                                    )}
                                />
                                <div className="clearfix" />
                                <Form.Text className="text-muted fs-13 clearfix">{errors.availability?.message}</Form.Text>
                            </Col>
                        </Row>
                        {selectedAvailability.choices?.length > 0 &&
                            <Row>
                                <Col sm={12}>
                                    <Form.Label className="fw-bold">Kondisi dan Fungsi :</Form.Label>
                                    <div className="mt-2">
                                        <Controller
                                            name="condition"
                                            control={control}
                                            render={({ field }) => (
                                                <>
                                                    {selectedAvailability.choices.map((item, key) =>
                                                        <div key={`select-${fKey}-${key}`} className="d-flex align-items-center mb-3">
                                                            <Checkbox
                                                                {...field}
                                                                inputId={`select-${fKey}-${key}`}
                                                                name="choices"
                                                                value={item}
                                                                onChange={onChoicesAvailabilityChange}
                                                                checked={selectedChoices.some((val) => val === item)}
                                                                className={classNames({ 'p-invalid': errors.condition?.message })} />
                                                            <label htmlFor={`select-${fKey}-${key}`} className="ms-3 pointer">{item}</label>
                                                        </div>
                                                    )}
                                                    <div key={`choices-condition`} className="d-flex align-items-center mb-3">
                                                        <Checkbox
                                                            inputId={`choices-condition`}
                                                            name="choices"
                                                            value={otherInput}
                                                            onChange={onChoicesOtherAvailabilityChange}
                                                            disabled={!otherInput?.length > 0}
                                                            checked={otherInput?.length > 0}
                                                            className={classNames({ 'p-invalid': errors.condition?.message })}
                                                        />
                                                        <Form.Group className="ms-3 w-100">
                                                            <Form.Control value={otherInput} {...register(`otherChoice`)} size="lg" type="text" placeholder="Pilihan lainnya..." autoComplete="off"
                                                                onBlur={() => methods.handleSubmit(onSubmit)()}
                                                                onChange={(e) => {
                                                                    setOtherInput(e.target.value);
                                                                    methods.handleSubmit(onSubmit)()
                                                                }}
                                                            />
                                                        </Form.Group>
                                                    </div>
                                                </>
                                            )} />
                                        <Form.Text className="text-muted fs-13 clearfix">{errors.condition?.message}</Form.Text>
                                    </div>
                                </Col>
                            </Row>
                        }
                    </> :
                    <>
                        {element.choices?.length > 0 &&
                            <Row>
                                <Col sm={12}>
                                    <Form.Label className="fw-bold">Kondisi dan Fungsi :</Form.Label>
                                    <div className="mt-2">
                                        <Controller
                                            name="condition"
                                            control={control}
                                            render={({ field }) => (
                                                <>
                                                    {element.choices.map((item, key) =>
                                                        <div key={`choices-${fKey}-${key}`} className="d-flex align-items-center mb-3">
                                                            <Checkbox
                                                                {...field}
                                                                inputId={`choices-${fKey}-${key}`}
                                                                name="choices"
                                                                value={item.name}
                                                                onChange={(e) => onChoicesAvailabilityChange(e)}
                                                                checked={selectedChoices.some((val) => val === item.name)}
                                                                className={classNames({ 'p-invalid': errors.condition?.message })}
                                                            />
                                                            <label htmlFor={`choices-${fKey}-${key}`} className="ms-3 pointer">{item.name}</label>
                                                        </div>
                                                    )}
                                                </>
                                            )} />
                                        <div key={`choices-${fKey}-a`} className="d-flex align-items-center mb-3">
                                            <Checkbox inputId={`choices-${fKey}-a`} name="otherChoices"
                                                value={otherInput}
                                                onChange={onChoicesOtherAvailabilityChange}
                                                disabled={!otherInput?.length > 0}
                                                checked={otherInput?.length > 0}
                                                className={classNames({ 'p-invalid': errors.condition?.message })}
                                            />
                                            <Form.Group className="ms-3 w-100">
                                                <Form.Control type="text" placeholder="Pilihan lainnya..." autoComplete="off"
                                                    value={otherInput}
                                                    {...register(`otherChoice`)}
                                                    onBlur={() => methods.handleSubmit(onSubmit)()}
                                                    onChange={(e) => {
                                                        setOtherInput(e.target.value);
                                                    }}
                                                />
                                            </Form.Group>
                                        </div>
                                        <Form.Text className="text-muted fs-13 clearfix">{errors.condition?.message}</Form.Text>
                                    </div>
                                </Col>
                            </Row>
                        }
                    </>
                }
                <Row>
                    <Col>
                        <Form.Group className="mb-3">
                            <Form.Label className='fw-bold'>Catatan :</Form.Label>
                            <Form.Control type="text" size='lg' as={'textarea'} autoComplete="off" {...register("note")} isInvalid={errors.note ? true : false} />
                            <Form.Text className="text-muted fs-13 clearfix">{errors.note?.message}</Form.Text>
                        </Form.Group>
                    </Col>
                </Row>
            </Form>
        </FormProvider>

    );
}

export default memo(FormOnChange);
